module.exports = __webpack_public_path__ + "media/images/company_logo/logo_m3-08b0c7d2bccb60819faa0a61b342b3d9.jpg";